import { render, staticRenderFns } from "./DxWorker.vue?vue&type=template&id=14a3a94a&scoped=true&"
import script from "./DxWorker.vue?vue&type=script&lang=js&"
export * from "./DxWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a3a94a",
  null
  
)

export default component.exports